module.exports = __webpack_public_path__ + "front/img/bg.b92a4924.png";